import { defineAction } from '~/prix'
import { z } from 'zod'
import materialDeleteAction from './materialDelete.action.json' with { type: 'json' }
import { materialObject } from '../materialObject'

const materialDeleteDefinition = defineAction({
  ...materialDeleteAction,

  input: materialObject.pick({
    id: true,
  }),
  output: z.object({}),
})

export default materialDeleteDefinition
